(function () {
  /* Official W1GK chart: size → recommended hand length (cm). Ranges = midpoints. */
  const DEFAULT_CHART = [
    { size: '5', cm_min: 0, cm_max: 16.5, label: '16 cm' },
    { size: '6', cm_min: 16.5, cm_max: 17.5, label: '17 cm' },
    { size: '7', cm_min: 17.5, cm_max: 18.5, label: '18 cm' },
    { size: '8', cm_min: 18.5, cm_max: 19.25, label: '19 cm' },
    { size: '8.5', cm_min: 19.25, cm_max: 19.75, label: '19,5 cm' },
    { size: '9', cm_min: 19.75, cm_max: 20.5, label: '20 cm' },
    { size: '10', cm_min: 20.5, cm_max: 21.25, label: '21 cm' },
    { size: '10.5', cm_min: 21.25, cm_max: 21.75, label: '21,5 cm' },
    { size: '11', cm_min: 21.75, cm_max: 99, label: '22 cm' },
  ];

  const readJson = (id) => {
    const el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  };

  const getSizeChart = () => {
    const pdp = readJson('w1gk-pdp-config');
    if (pdp?.sizeChart?.length) return pdp.sizeChart;
    const global = readJson('w1gk-glove-finder-config');
    if (global?.sizeChart?.length) return global.sizeChart;
    return DEFAULT_CHART;
  };

  const normalizeRow = (row) => ({
    size: String(row.size ?? row[0] ?? ''),
    cm_min: Number(row.cm_min ?? row.min ?? 0),
    cm_max: Number(row.cm_max ?? row.max ?? 99),
    label: row.label || '',
  });

  const formatRange = (row) => {
    if (row.label) return row.label;
    if (row.cm_max >= 99) return `powyżej ${row.cm_min} cm`;
    if (row.cm_min <= 0) return `do ${row.cm_max} cm`;
    return `${row.cm_min} – ${row.cm_max} cm`;
  };

  const findSizeForCm = (chart, cm) => {
    const rows = chart.map(normalizeRow).filter((r) => r.size);
    for (let i = 0; i < rows.length; i += 1) {
      const row = rows[i];
      const isLast = i === rows.length - 1;
      const inRange = isLast ? cm >= row.cm_min : cm >= row.cm_min && cm < row.cm_max;
      if (inRange) return row;
    }
    return null;
  };

  const renderChartGrid = (modal, chart) => {
    const grid = modal.querySelector('[data-w1gk-chart-grid-fallback]');
    if (!grid) return;
    grid.innerHTML = '';
    const headSize = document.createElement('div');
    headSize.className = 'w1gk-pdp-sizer__chart-head';
    headSize.textContent = 'Rozmiar';
    const headLen = document.createElement('div');
    headLen.className = 'w1gk-pdp-sizer__chart-head';
    headLen.textContent = 'Długość dłoni';
    grid.append(headSize, headLen);
    chart.map(normalizeRow).forEach((row) => {
      const sizeCell = document.createElement('div');
      sizeCell.textContent = row.size;
      const rangeCell = document.createElement('div');
      rangeCell.className = 'w1gk-pdp-sizer__chart-muted';
      rangeCell.textContent = formatRange(row);
      grid.append(sizeCell, rangeCell);
    });
  };

  const selectSizeOnPdp = (size) => {
    const raw = String(size);
    const candidates = [raw, raw.replace('.', ','), raw.replace(',', '.')];
    for (const s of candidates) {
      const btn = document.querySelector(`[data-w1gk-size="${CSS.escape(s)}"]:not(:disabled)`);
      if (btn) {
        btn.click();
        return true;
      }
    }
    return false;
  };

  const resetResult = (modal) => {
    modal.querySelector('[data-w1gk-cm-result-wrap]')?.setAttribute('hidden', '');
    modal.querySelector('[data-w1gk-cm-out-of-range]')?.setAttribute('hidden', '');
    modal.querySelector('[data-w1gk-sizer-ctas]')?.setAttribute('hidden', '');
    const apply = modal.querySelector('[data-w1gk-apply-size]');
    if (apply) delete apply.dataset.w1gkApplySize;
  };

  const syncToggleLabel = (toggle, expanded) => {
    if (!toggle) return;
    const closed = toggle.dataset.labelClosed || 'Pokaż tabelę rozmiarów';
    const open = toggle.dataset.labelOpen || 'Zwiń tabelę rozmiarów';
    toggle.textContent = expanded ? open : closed;
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const bindModal = () => {
    const modal = document.querySelector('[data-w1gk-sizer-modal]');
    if (!modal || modal.dataset.w1gkFinderBound === 'true') return;
    modal.dataset.w1gkFinderBound = 'true';

    const chart = getSizeChart();
    renderChartGrid(modal, chart);

    const open = () => {
      modal.hidden = false;
      document.body.classList.add('w1gk-pdp-modal-open');
      modal.querySelector('[data-w1gk-cm-input]')?.focus();
    };

    const close = () => {
      modal.hidden = true;
      document.body.classList.remove('w1gk-pdp-modal-open');
    };

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-w1gk-open-sizer]');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();

      /* Zamknij menu drawer, potem otwórz popup nad wszystkim */
      const menuDrawer = document.querySelector('[data-w1gk-menu-drawer]');
      if (menuDrawer?.classList.contains('is-open')) {
        menuDrawer.classList.remove('is-open');
        menuDrawer.hidden = true;
        menuDrawer.setAttribute('hidden', '');
        menuDrawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('w1gk-menu-open');
      }

      open();
    });

    modal.querySelectorAll('[data-w1gk-modal-close], [data-w1gk-modal-backdrop]').forEach((el) => {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    const toggle = modal.querySelector('[data-w1gk-chart-toggle]');
    const panel = modal.querySelector('[data-w1gk-chart-panel]');
    if (toggle && panel) {
      syncToggleLabel(toggle, !panel.hidden);
      toggle.addEventListener('click', () => {
        const willShow = panel.hidden;
        panel.hidden = !willShow;
        syncToggleLabel(toggle, willShow);
      });
    }

    const cmInput = modal.querySelector('[data-w1gk-cm-input]');
    const resultWrap = modal.querySelector('[data-w1gk-cm-result-wrap]');
    const resultSize = modal.querySelector('[data-w1gk-cm-result-size]');
    const resultDetail = modal.querySelector('[data-w1gk-cm-result-detail]');
    const outOfRange = modal.querySelector('[data-w1gk-cm-out-of-range]');
    const ctaRow = modal.querySelector('[data-w1gk-sizer-ctas]');
    const applyBtn = modal.querySelector('[data-w1gk-apply-size]');

    if (cmInput) {
      cmInput.addEventListener('input', () => {
        resetResult(modal);
        const cm = Number(String(cmInput.value).replace(',', '.'));
        if (!cm) return;

        const row = findSizeForCm(chart, cm);
        if (!row) {
          outOfRange?.removeAttribute('hidden');
          return;
        }

        resultSize.textContent = row.size;
        resultDetail.textContent = `odpowiednie dla dłoni ${formatRange(row)}`;
        resultWrap?.removeAttribute('hidden');

        /* Keep both CTAs: apply size (PDP when possible) + shop link. */
        applyBtn.dataset.w1gkApplySize = row.size;
        ctaRow?.removeAttribute('hidden');

        selectSizeOnPdp(row.size);
      });
    }

    applyBtn?.addEventListener('click', () => {
      const size = applyBtn.dataset.w1gkApplySize;
      if (!size) return;
      if (selectSizeOnPdp(size)) {
        close();
        return;
      }
      /* Outside PDP / no size grid yet — keep button, filtering later. */
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindModal);
  } else {
    bindModal();
  }
})();
